import styled from 'foundations-theming/utils';
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useMemo, useState } from 'react';
import getIn from 'transmute/getIn';
import { getData } from 'calling-lifecycle-internal/async-flux-utils/operators/getApiProperties';
import { getIsCallIncoming, getShouldShowActiveCallState } from 'calling-internal-common/widget-status/operators/getCallState';
import { getIsTabCall } from 'calling-ui-library/utils/widgetDetailsOperators';
// @ts-expect-error not typed
import SearchableCalleeList from 'calling-ui-library/callee-select/components/SearchableCalleeList';
import CallSettingsIcon from 'calling-ui-library/callee-select/components/CallSettingsIcon';

// @ts-expect-error not typed
import CurrentSettingsInfoActivityCreator from './CurrentSettingsInfoActivityCreator';
import { getCallableObjectAndAssociations } from 'calling-lifecycle-internal/callee-omnibus/operators/calleeOmnibusResultGetters';
import { useWidgetDetails } from 'calling-cross-tab-library/external/useWidgetDetails';
import { getCallStatus } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { getIsProviderHubSpot, getIsTwilioBasedCallProvider } from 'calling-lifecycle-internal/call-provider/operators/getIsTwilioBasedCallProvider';
import { hasPaidSeatAccess } from 'calling-orchestration-shared-library/hub-info/utils/hasCallingFeature';
import { getHubSpotCallingEnabled, getInstalledCallingApplications, getPhoneNumbers } from '../../callee-omnibus/operators/settingsOmnibusResultGetters';
import ChangeProviderButtonWrapper from './ChangeProviderButtonWrapper';
import { CALLEE_NUMBERS } from 'calling-ui-library/calling-remote-redesign/constants/changeProviderButtonLocations';
import { Spacer } from 'foundations-components/components/Spacer';
import { getHasMultipleProviders } from '../utils/getHasMultipleProviders';
import ProviderName from './ProviderName';
import { useHandleOpenWindowAndStartCall } from 'calling-ui-library/calling-remote-redesign/hooks/useHandleOpenWindowAndStartCall';
import { ACTIVITY_CREATOR } from 'calling-internal-common/constants/appIdentifiers';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallNotesButtonWrapper = styled.div.withConfig({
  displayName: "CallSettingsNumbersActivityCreator__CallNotesButtonWrapper",
  componentId: "wzjyym-0"
})(["position:sticky;bottom:0;background:", ";border-style:solid;border-width:", ";border-color:", ";"], ({
  theme
}) => theme.color['do-not-use-olaf'], ({
  theme
}) => `${theme.borderWidth['200']} ${theme.borderWidth['0']} ${theme.borderWidth['0']} ${theme.borderWidth['0']}`, ({
  theme
}) => theme.color['do-not-use-koala']);
const CalleeSelectDropdownWrapper = styled.div.withConfig({
  displayName: "CallSettingsNumbersActivityCreator__CalleeSelectDropdownWrapper",
  componentId: "wzjyym-1"
})(["max-height:400px;overflow:auto;"]);
const CallSettingsNumbersActivityCreator = props => {
  const {
    widgetDetails
  } = useWidgetDetails();
  const crossTabCallStatus = getCallStatus(widgetDetails);
  const [selectedFromNumber, setSelectedFromNumber] = useState(props.defaultFromNumber);
  const {
    asyncCalleeOmnibus,
    asyncSettingsOmnibus,
    widgetState,
    selectedCallProvider,
    scopes,
    limits,
    gates,
    appIdentifier,
    onCallButtonClick,
    defaultFromNumber,
    prospectingQueueItemId
  } = props;
  const calleeOmnibusData = getData(asyncCalleeOmnibus);
  const calleesData = calleeOmnibusData && getCallableObjectAndAssociations(calleeOmnibusData);
  const settingsOmnibusData = getData(asyncSettingsOmnibus);
  const installedCallingApplications = getInstalledCallingApplications(settingsOmnibusData);
  const shouldShowActiveCallState = getShouldShowActiveCallState(widgetState.get('callStatus'));
  const isActiveCallTab = getIsTabCall(widgetDetails);
  const isThirdPartyActive = getIn(['isThirdPartyActive'], widgetState);
  const isFreeCallingAndHS = !hasPaidSeatAccess() && getIsProviderHubSpot(selectedCallProvider);
  const isCallTabActive = (getShouldShowActiveCallState(crossTabCallStatus) || getIsCallIncoming(crossTabCallStatus)) && isActiveCallTab;
  const {
    startOutboundCall
  } = useHandleOpenWindowAndStartCall({
    defaultFromNumber,
    selectedCallProvider,
    onCallButtonClick,
    appIdentifier,
    gates,
    prospectingQueueItemId
  });
  const disabledTooltipMessage = isFreeCallingAndHS ? 'callSettingsOptions.freeSeatHubSpotCallingBlocked' : isCallTabActive ? 'callSettingsOptions.callActiveOutboundCallBlocked' : null;
  const showCurrentSettingsInfo = useMemo(() => {
    return getIsTwilioBasedCallProvider(selectedCallProvider);
  }, [selectedCallProvider]);
  const hasMultipleProviders = useMemo(() => getHasMultipleProviders({
    installedCallingApplicationsLength: (installedCallingApplications === null || installedCallingApplications === void 0 ? void 0 : installedCallingApplications.length) || 0,
    fromNumbers: getPhoneNumbers(settingsOmnibusData),
    isHubSpotEnabled: getHubSpotCallingEnabled(selectedCallProvider)
  }), [installedCallingApplications, settingsOmnibusData, selectedCallProvider]);
  const showProviderName = useMemo(() => {
    return !getIsTwilioBasedCallProvider(selectedCallProvider) && hasMultipleProviders;
  }, [selectedCallProvider, hasMultipleProviders]);
  const showChangeProviderButton = useMemo(() => {
    return appIdentifier !== ACTIVITY_CREATOR && hasMultipleProviders;
  }, [appIdentifier, hasMultipleProviders]);
  return /*#__PURE__*/_jsxs(CalleeSelectDropdownWrapper, {
    children: [/*#__PURE__*/_jsx(SearchableCalleeList, {
      appIdentifier: props.appIdentifier,
      calleesData: calleesData,
      onSelectToNumber: startOutboundCall,
      disabled: !!disabledTooltipMessage,
      canEdit: false,
      showAddPropertyButton: false,
      CallSettingsIcon: CallSettingsIcon,
      disabledTooltipMessage: disabledTooltipMessage
    }), showProviderName && /*#__PURE__*/_jsx(ProviderName, {
      selectedCallProvider: selectedCallProvider
    }), showCurrentSettingsInfo &&
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx(CallNotesButtonWrapper, {
      children: /*#__PURE__*/_jsx(CurrentSettingsInfoActivityCreator, {
        asyncSettingsOmnibus: asyncSettingsOmnibus,
        disabled: isThirdPartyActive || shouldShowActiveCallState,
        limits: limits,
        scopes: scopes,
        onSelectFromNumber: setSelectedFromNumber,
        selectedCallProvider: selectedCallProvider,
        selectedFromNumber: selectedFromNumber,
        showFromNumberDropdown: getIsTwilioBasedCallProvider(selectedCallProvider)
      })
    }), showChangeProviderButton && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ChangeProviderButtonWrapper, {
        providerName: selectedCallProvider.name,
        location: CALLEE_NUMBERS,
        gates: gates
      }), /*#__PURE__*/_jsx(Spacer, {
        space: "100"
      })]
    })]
  });
};
export default CallSettingsNumbersActivityCreator;